import React from 'react';
import InputSmsField from './InputSmsField';

type Props = {
  isValidPhoneNum: boolean,
  formIsValid: boolean,
  loadingStep: boolean,
  numbersEligibleUSCanada: string,
  requiredNumberWarning: string,
  setUserInfo: Function,
  userInfo: any,
  errorMessage: string | null,
}

function ShowSmsFormStepOne({
  isValidPhoneNum,
  formIsValid,
  loadingStep,
  numbersEligibleUSCanada,
  requiredNumberWarning,
  setUserInfo,
  userInfo,
  errorMessage,
} : Props) {
  return (
    <>
      <InputSmsField
        validValue
        name="phone"
        value={userInfo.phone}
        setUserInfo={setUserInfo}
        placeholder="123-456-7890"
        userInfo={userInfo}
      />
      <div className="flex justify-center mt-[21px]">
        <p className="selection:text-[14px] leading-normal text-center w-full">
          {!isValidPhoneNum ? (
            requiredNumberWarning
          ) : (
            'Valid phone number'
          )}
        </p>
      </div>
      <button
        type="submit"
        className={`${formIsValid
          ? 'font-bold shadow-md cursor-pointer'
          : 'cursor-normal w-1/3'
        } font-bold bg-black text-chdBlue-light text-[14px] p-2 tracking-widest rounded-sm w-[150px] h-[47px] uppercase block my-[26px] md:my-[24px]`}
        disabled={!formIsValid}
      >
        {loadingStep && 'Loading...'}
        {!errorMessage && !loadingStep && 'Continue'}
        {errorMessage && 'Error Occurred. Try Again?'}
      </button>
      {errorMessage && <p className="text-[#ff0000]">{errorMessage}</p>}
      <p className="text-[15px] italic text-center tracking-normal font-normal">{numbersEligibleUSCanada}</p>
    </>
  );
}

export default ShowSmsFormStepOne;
